import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { COIN_HELP_URL } from 'common/utils';
import Button from 'components/common/Button';
import useGlobalStore from 'store/global';

import HelpPopover from '../HelpPopover';
import styles from './CoinRemainingSection.module.scss';

const CoinRemainingSection = ({
  sum,
  consumable,
  onClose,
  smallMode = false,
  hideWarningText = false,
  hideUpcomingCoin = false,
}: {
  sum: number;
  consumable: number;
  onClose: () => void;
  smallMode: boolean;
  hideWarningText?: boolean;
  hideUpcomingCoin?: boolean;
}) => {
  const router = useRouter();
  const userCoinDetails = useGlobalStore((state) => state.userCoinDetails);
  const upComingCoin = userCoinDetails?.upcoming_coin_amount;
  // without mission coin
  if (sum === consumable) {
    return (
      <div className={styles.withoutMissionCoin}>
        <div className={styles.coinIcon}>
          <Image src="/images/icons/coin.png" height={120} width={120} />
        </div>
        <div className={styles.coinRemaining}>
          <span className={styles.text}>現在のコイン残高</span>
          <span className={styles.number}>{sum?.toLocaleString()}</span>
          {!hideUpcomingCoin && (
            <div className={styles.allUpcomingCoin}>
              <span className={styles.allUpcomingCoinText}>獲得予定コイン</span>
              <span className={styles.allUpcomingCoinNumber}>
                {upComingCoin?.toLocaleString()}
                <HelpPopover
                  tooltipWidth={200}
                  className={styles.helpIcon}
                  content={
                    <div className={styles.helpContent}>
                      残りの獲得予定コインを表示しています。詳しくは、
                      <a href={COIN_HELP_URL} target="_blank">
                        こちら
                      </a>
                      をご覧ください。
                    </div>
                  }
                />
              </span>
            </div>
          )}
        </div>
      </div>
    );
  }
  // with mission coin
  const upComingMissionCoin = sum - consumable;
  return (
    <div className={styles.withMissionCoin}>
      <div className={styles.coinInfo}>
        <div className={styles.coinIcon}>
          <Image src="/images/icons/coin.png" height={120} width={120} />
        </div>
        <div className={styles.coinRemaining}>
          <span className={styles.text}>現在のコイン残高</span>
          <span className={styles.number}>
            {sum?.toLocaleString()}
            <span style={{ fontSize: '14px', marginLeft: '5px' }}>(※)</span>
          </span>
          {!hideUpcomingCoin && (
            <div className={styles.allUpcomingCoin}>
              <span className={styles.allUpcomingCoinText}>獲得予定コイン</span>
              <span className={styles.allUpcomingCoinNumber}>
                {upComingCoin?.toLocaleString()}
                <HelpPopover
                  tooltipWidth={200}
                  className={styles.helpIcon}
                  content={
                    <div className={styles.helpContent}>
                      残りの獲得予定コインを表示しています。詳しくは、
                      <a href={COIN_HELP_URL} target="_blank">
                        こちら
                      </a>
                      をご覧ください。
                    </div>
                  }
                />
              </span>
            </div>
          )}
        </div>
      </div>
      <div
        className={classNames(styles.verifySection, {
          [styles.smallMode]: smallMode,
        })}
      >
        {!smallMode ? (
          <div className={styles.warningText}>
            ※ミッションで獲得したコイン
            <span style={{ color: '#FDE82B', fontWeight: 600 }}>
              ({upComingMissionCoin?.toLocaleString()})
            </span>
            は
            <br />
            電話番号の認証後に利用可能となります
          </div>
        ) : (
          !hideWarningText && (
            <div className={styles.warningTextWithBtn}>
              ※ミッションで獲得したコイン
              <span style={{ color: '#FDE82B', fontWeight: 600 }}>
                ({upComingMissionCoin?.toLocaleString()})
              </span>
              は
              <a
                onClick={() => {
                  void router.push(`/account/verify_phone`);
                  onClose();
                }}
              >
                電話番号の認証
              </a>
              後に利用可能となります
            </div>
          )
        )}
        {!smallMode && (
          <div className={styles.button}>
            <Button
              text="電話番号を認証する"
              onClick={() => {
                void router.push(`/account/verify_phone`);
                onClose();
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CoinRemainingSection;
